import { render, staticRenderFns } from "./lnvnMove.vue?vue&type=template&id=2a00ce27&"
import script from "./lnvnMove.vue?vue&type=script&lang=js&"
export * from "./lnvnMove.vue?vue&type=script&lang=js&"
import style0 from "./lnvnMove.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports